import { getSessionStore } from "app/utils/sessionStore";
import IappLightModeLogo from "../../assets/IAPPLogoColor.svg";
import BEEICON from "../../assets/BEE.png";

function LeftPanelBrandingLogo({ isOpen }: { isOpen: boolean }) {
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryLogo = "", secondaryLogo = "" } = branding ?? "";

  return (
    <div className="flex justify-center items-center">
      {isOpen ? (
        <div className="mb-2 py-3 flex justify-center items-center w-full h-20">
          {primaryLogo ? (
            <img src={primaryLogo} className="object-contain" alt="primary logo" />
          ) : (
            <img src={IappLightModeLogo} className="object-contain" alt="logo" />
          )}
        </div>
      ) : (
        <div className="mb-2 py-3 flex justify-center items-center w-20 h-20 rounded-3xl overflow-hidden">
          {secondaryLogo ? (
            <img src={secondaryLogo} className="object-contain" alt="secondary logo" />
          ) : (
            <img src={BEEICON} className="object-scale-down" alt="bee icon" />
          )}
        </div>
      )}
    </div>
  );
}

export default LeftPanelBrandingLogo;
